import { render, staticRenderFns } from "./VotingArea.vue?vue&type=template&id=8798a35a&"
import script from "./VotingArea.vue?vue&type=script&lang=ts&"
export * from "./VotingArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports